// extracted by mini-css-extract-plugin
export default {"container":"Blocked_container__qdgPu","inner":"Blocked_inner__C3qVY"};